import React from 'react';
import { useHistory } from 'react-router-dom';
import styles from './Skill.module.scss';
import Actions from '../actions/Actions';
import ContentAudio from '../../../../components/content-audio/ContentAudio';
import Button from '../../../../components/button/Button';

type Props = {
  data: string;
  description?: string | null;
  isFullScreen: boolean;
  isPreview?: boolean;
  goBack?: () => void;
  onExit?: () => void;
  isParentApp?: boolean;
};

function Audio(props: Props) {
  const { data, description, isFullScreen, isPreview, goBack, onExit, isParentApp } = props;
  const { push } = useHistory();
  const onGoToPADashboard = () => {
    if (isParentApp && onExit) {
      onExit();
    } else {
      push('/parent/dashboard');
    }
  }

  return (
    <Actions fullScreen={isFullScreen} rightButton={<Button size={'extraSmall'} onClick={onGoToPADashboard} label={'GO TO DASHBOARD'} className={styles.paGoTo} />} isPreview={isPreview} goBack={goBack}>
      <div className={styles.container}>
        <div className={isFullScreen || isPreview ? styles.description : styles.whiteDescription}>
          {description || ''}
        </div>
        <div className={styles.content}>
          <ContentAudio data={data}/>
        </div>
      </div>
    </Actions>
  );
}

export default Audio;
